import { h } from "../kit/dom.ts";

/**
 * Ângulo na tela (graus, 0 = para cima, horário) de quem bateu em `me`, com a câmera em `yaw` (0 olha para
 * −z; positivo vira à esquerda). Pura, para os testes.
 */
export function chevronAngle(yaw: number, me: { x: number; z: number }, from: { x: number; z: number }): number {
  const dx = from.x - me.x;
  const dz = from.z - me.z;
  const ahead = -dx * Math.sin(yaw) - dz * Math.cos(yaw);
  const right = dx * Math.cos(yaw) - dz * Math.sin(yaw);
  return (Math.atan2(right, ahead) * 180) / Math.PI;
}

/** Quantos chevrons ao mesmo tempo (o mais velho dá lugar). */
const POOL = 4;

/**
 * Dano recebido (F76, doc 09 §2.3): o número fica branco e um chevron em volta da mira aponta a origem, na
 * cor da fonte (laranja do inimigo, vermelho do chefe, o slot de um jogador na Arena). Some em 1 s pelo CSS.
 */
export class DamageChevrons {
  readonly element: HTMLElement;
  private readonly items: HTMLElement[] = [];
  private next = 0;

  constructor(parent: HTMLElement) {
    this.element = h("div", { id: "chevrons", "aria-hidden": "true" });
    for (let i = 0; i < POOL; i++) {
      const el = h("span", { class: "chevron" }, "▲");
      this.items.push(el);
      this.element.appendChild(el);
    }
    parent.appendChild(this.element);
  }

  show(angle: number, color: string): void {
    const el = this.items[this.next]!;
    this.next = (this.next + 1) % POOL;
    el.style.setProperty("--ang", `${angle.toFixed(1)}deg`);
    el.style.setProperty("--cor", color);
    el.classList.remove("ativo");
    void el.offsetWidth;
    el.classList.add("ativo");
  }

  remove(): void {
    this.element.remove();
  }
}
